var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        { staticClass: "padding p-3" },
        [
          _c(
            "el-form",
            { attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "經銷商" } },
                [
                  _c("selectCompany", {
                    attrs: { id: _vm.company_id },
                    on: {
                      "update:id": function ($event) {
                        _vm.company_id = $event
                      },
                      onSelect: _vm.onSelectCompany,
                    },
                  }),
                  _vm.selected.length && _vm.$route.meta.action.d
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.deleteProducts },
                        },
                        [_vm._v(" 刪除 ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _vm.$route.meta.action.e
                    ? _c("ExportExcel", {
                        attrs: {
                          "export-data": _vm.exportData.rows,
                          columns: _vm.columns,
                          filename: "商品資料",
                        },
                        on: { onExportClick: _vm.onExportClick },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50],
              "page-size": _vm.size,
              layout: "sizes, prev, pager, next",
              total: _vm.products.count,
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function ($event) {
                _vm.currentPage = $event
              },
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.products.rows, stripe: "" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _vm.$route.meta.action.d
            ? _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { prop: "ProductNo", label: "品號", width: "80" },
          }),
          _c("el-table-column", {
            attrs: { prop: "ProductNa", label: "品名" },
          }),
          _c("el-table-column", {
            attrs: { prop: "UnitPrice", label: "單價", width: "80" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50],
              "page-size": _vm.size,
              layout: "sizes, prev, pager, next",
              total: _vm.products.count,
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function ($event) {
                _vm.currentPage = $event
              },
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }